/**
 * @license Copyright (c) 2014-2020, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
import ClassicEditor from "@ckeditor/ckeditor5-editor-classic/src/classiceditor.js";
import Autoformat from "@ckeditor/ckeditor5-autoformat/src/autoformat.js";
import BlockQuote from "@ckeditor/ckeditor5-block-quote/src/blockquote.js";
import Bold from "@ckeditor/ckeditor5-basic-styles/src/bold.js";
import Underline from "@ckeditor/ckeditor5-basic-styles/src/underline.js";
import Essentials from "@ckeditor/ckeditor5-essentials/src/essentials.js";
import FontSize from "@ckeditor/ckeditor5-font/src/fontsize.js";
import Heading from "@ckeditor/ckeditor5-heading/src/heading.js";
import HtmlEmbed from "@ckeditor/ckeditor5-html-embed/src/htmlembed.js";
import Image from "@ckeditor/ckeditor5-image/src/image.js";
import Indent from "@ckeditor/ckeditor5-indent/src/indent.js";
import Indentblock from "@ckeditor/ckeditor5-indent/src/indentblock";
import Italic from "@ckeditor/ckeditor5-basic-styles/src/italic.js";
import Link from "@ckeditor/ckeditor5-link/src/link.js";
import List from "@ckeditor/ckeditor5-list/src/list.js";
import ListStyle from "@ckeditor/ckeditor5-list/src/liststyle.js";
import MediaEmbed from "@ckeditor/ckeditor5-media-embed/src/mediaembed.js";
import Paragraph from "@ckeditor/ckeditor5-paragraph/src/paragraph.js";
import Table from "@ckeditor/ckeditor5-table/src/table.js";
import TableToolbar from "@ckeditor/ckeditor5-table/src/tabletoolbar.js";
import TextTransformation from "@ckeditor/ckeditor5-typing/src/texttransformation.js";
import Gallery from "./Gallery/Gallery";
import EmbeddedPost from "./EmbeddedPost/EmbeddedPost";
import CDNImage from "./CDNImage/CDNImage";
import InfoImage from "./InfoImage/InfoImage";
import DocumentBox from "./DocumentBox/DocumentBox";
import ProductList from "./ProductList/ProductList";

class Editor extends ClassicEditor {}

// Plugins to include in the build.
Editor.builtinPlugins = [
    Autoformat,
    BlockQuote,
    Bold,
    Underline,
    Essentials,
    FontSize,
    Heading,
    HtmlEmbed,
    Image,
    Indent,
    Indentblock,
    Italic,
    Link,
    List,
    ListStyle,
    MediaEmbed,
    Paragraph,
    Table,
    TableToolbar,
    TextTransformation,
    Gallery,
    EmbeddedPost,
    CDNImage,
    InfoImage,
    DocumentBox,
    ProductList,
];

export default Editor;
